import * as React from 'react';
const SvgKol = (props) => (
  <svg viewBox="0 0 124 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m86.303 97.83 27.436-12.428a5.808 5.808 0 0 1 7.718 2.804c1.35 2.91.097 6.36-2.807 7.71l-42.533 21.267a7.746 7.746 0 0 1-4.98.667l-45.915-9.518H17.48"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.195 98.67h27.098a5.805 5.805 0 0 0 5.806-5.8c0-3.2-2.603-5.8-5.806-5.8H62.002c-11.613-13.534-36.775-5.8-36.775-5.8h-7.743M2 75.47h15.484v38.668H2M43.14 28.217a13.501 13.501 0 0 1 5.313-1.083c7.481 0 13.549 6.062 13.549 13.534 0 7.473-6.068 13.534-13.549 13.534-7.48 0-13.549-6.061-13.549-13.534 0-1.817.358-3.548 1.007-5.128M92.97 29.068c7.483 0 13.55-6.06 13.55-13.534C106.52 8.059 100.453 2 92.97 2c-7.482 0-13.548 6.06-13.548 13.534 0 7.474 6.066 13.534 13.549 13.534ZM92.97 79.336c7.483 0 13.55-6.06 13.55-13.534 0-7.474-6.067-13.533-13.55-13.533-7.482 0-13.548 6.059-13.548 13.533 0 7.475 6.066 13.534 13.549 13.534ZM60.24 47.324l20.943 11.823M60.24 34.012 81.183 22.19"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgKol;
